// extracted by mini-css-extract-plugin
export default {"inputs":"auth_inputs__HDWCs","LoginButton":"auth_LoginButton__Lo3q5","Iconcenter":"auth_Iconcenter__cpH00"};